import {
    Box,
    FormControl,
    FormHelperText,
    IconButton,
    InputAdornment,
    InputLabel,
    MenuItem,
    OutlinedInput,
    Select,
} from '@mui/material';
import { FC, useState, MouseEvent } from 'react';
import { useTranslation } from 'react-i18next';
import ClearIcon from '@mui/icons-material/Clear';
import { Defect } from '../types';
import DefectSelectorMenu from './DefectSelectorMenu';

interface DefectSelectorProps {
    value: Defect | null;
    onChange: (defect: Defect | null) => void;
    error?: boolean;
    helperText?: string;
}

const DefectSelector: FC<DefectSelectorProps> = ({ value, onChange, error, helperText }) => {
    const { t } = useTranslation();
    const [open, setOpen] = useState(false);

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleClear = () => {
        onChange(null);
    };

    const handleMouseDownClear = (event: MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
    };

    const handleSelect = (defect: Defect) => {
        onChange(defect);
        setOpen(false);
    };

    return (
        <FormControl fullWidth size="small" error={error}>
            <InputLabel id="defect-select">{t('defect')}</InputLabel>
            <Select
                labelId="defect-select"
                value={' '}
                renderValue={() => {
                    if (!value) {
                        return <Box sx={{ color: 'text.disabled' }}>{t('choose_defect')}...</Box>;
                    }
                    return `#${value.pk} ${value.name}`;
                }}
                open={open}
                onOpen={handleOpen}
                onClose={handleClose}
                input={
                    <OutlinedInput
                        sx={{
                            '& .MuiSelect-select': {
                                paddingRight: '0 !important',
                            },
                        }}
                        label={t('defect')}
                        endAdornment={
                            value && (
                                <InputAdornment position="start" sx={{ mr: 2 }}>
                                    <IconButton size="small" onClick={handleClear} onMouseDown={handleMouseDownClear}>
                                        <ClearIcon />
                                    </IconButton>
                                </InputAdornment>
                            )
                        }
                    />
                }
                MenuProps={{
                    PaperProps: {
                        sx: {
                            height: 400,
                            width: 400,
                        },
                    },
                }}
            >
                <MenuItem sx={{ position: 'absolute', visibility: 'hidden' }} value={' '} />
                <DefectSelectorMenu open={open} onClose={handleClose} onChange={handleSelect} />
            </Select>
            {helperText && <FormHelperText>{helperText}</FormHelperText>}
        </FormControl>
    );
};

export default DefectSelector;
